import { render, staticRenderFns } from "./HeaderMenuLink.vue?vue&type=template&id=0a14b82b&scoped=true&"
import script from "./HeaderMenuLink.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenuLink.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMenuLink.vue?vue&type=style&index=0&id=0a14b82b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14b82b",
  null
  
)

export default component.exports